import { useCallback } from 'react';
import { useFunnelMapApiFacade } from '../../../../../apis/facades/funnel-map/useFunnelMapApiFacade';
import { ConfigurationItem } from '../../../../parser/ParserTypes';
import { createConfigurationItemFromParserResponseItem } from '../../../../parser/parserUtils';

export const useFetchConfigurationItem = () => {
  const { get_metadataByMetadataId } = useFunnelMapApiFacade();

  const fetchConfigurationItem = useCallback(
    async (metadataElementId: string, crmOrgId: string): Promise<ConfigurationItem> => {
      const cardType = await get_metadataByMetadataId(metadataElementId, crmOrgId);

      const objectName = 'objectName' in cardType.metadata ? cardType.metadata.objectName : '';
      const assureNotEmptyProps = {
        objectName,
        namespace: '',
      };

      return createConfigurationItemFromParserResponseItem({
        responseItem: { ...assureNotEmptyProps, ...cardType.metadata },
        objectApiName: objectName,
        keyType: cardType.metadata.type,
      });
    },
    [get_metadataByMetadataId],
  );

  return { fetchConfigurationItem };
};
